<template>
  <BaseIndex
    ref="baseIndex"
   :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="stockAdjustmentItems"
    :indexNested="true"
    :disablePagination="true"
    :maskFields="maskFields"
  >
    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        :stockAdjustment="stockAdjustment"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit v-if="item.id"
        :entry="item"
        :stockAdjustment="stockAdjustment"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :stockAdjustment="stockAdjustment"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      // tableHeaders: [],
      maskFields: [
        { field: 'price', mask: 'currency_10d' },
        // { field: 'quantityBeforeConsumption', mask: 'number' },
        { field: 'quantity', mask: 'number' },
        // { field: 'quantityAfterConsumption', mask: 'number' },
        // { field: 'totalPrice', mask: 'currency'}
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    stockAdjustmentItems: { 
      type: Array,
      default: () => []
    },
    stockAdjustment: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: { // utilizado para definir se o form é de edição
      type: Boolean,
      default: false
    },
    modelNameSingular: {
      type: String,
      default: "Item de Ajuste de Estoque"
    },
    modelNamePlural: {
      type: String,
      default: "Itens de Ajuste de Estoque"
    },
  },
  created() {
  },
  computed: {
    tableHeaders() {
      return [
        { text: "Item", align: "left", sortable: true, value: "item.name" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
        { text: "Unidade", align: "left", sortable: true, value: "item.unit.name" },
        // { text: "Qtd. Atual", align: "left", sortable: true, value: "quantityBeforeConsumption" },
        ... this.stockAdjustment.isStockEntryType ? [{ text: "Qtd. Adicionada", align: "left", sortable: true, value: "quantity" }] : [{ text: "Qtd. Removida", align: "left", sortable: true, value: "quantity" }],
        // { text: "Qtd. Final", align: "left", sortable: true, value: "quantityAfterConsumption" },
        ... this.stockAdjustment.isStockEntryType ? [{ text: "Preço Unit.", align: "left", sortable: true, value: "price" }] : [],
        { text: "Ações", value: "action", sortable: false }
        // { text: "Item", align: "left", sortable: true, value: "item.name" },
        // { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
        // ... this.objectType == "PurchaseItem" ? [{ text: "Estoque", align: "left", sortable: true, value: "stock.name" }] : [],
        // { text: "R$", align: "left", sortable: true, value: "price" },
        // ... this.objectType == "StockItem" ? [{ text: "Qtd. Disponível", align: "left", sortable: true, value: "availableQuantity" }] : [{ text: "Qtd.", align: "left", sortable: true, value: "purchaseQuantity" }],
        // { text: "Und.", align: "left", sortable: true, value: "item.unit.name" },
        // ... this.objectType == "StockItem" ? [{ text: "R$ Total", align: "left", sortable: true, value: "availableTotalPrice" }] : [{ text: "R$ Total", align: "left", sortable: true, value: "totalPrice" }],
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        // ... !this.readOnly ? [{ text: "Ações", value: "action", sortable: false }] : []
      ]
    }
  },
  methods: {
    entryUpdated: function(editedEntry){
      console.log("entry_updated", editedEntry);
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(editedEntry){
      this.stockAdjustmentItems.push(editedEntry);
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(editedEntry){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
  }
};
</script>

<style scoped></style>
